// core/dom-load-listener.js

/**
 * Initializes event listeners to add classes to the documentElement
 * based on the document and window load states.
 */
export function initializeDomLoadListeners() {
  // These classes are for the very first page load.
  document.documentElement.classList.add('dom-load');
  if (document.readyState === 'interactive') {
    document.documentElement.classList.add('readystate-interactive');
  }
  document.addEventListener('readystatechange', () => {
    if (document.readyState === 'complete') {
      document.documentElement.classList.add('readystate-complete');
    }
  });
  window.addEventListener('load', () => {
    document.documentElement.classList.add('window-load');
  });
}
